export default function CatalogEntryStatusBadges({
  items = [],
  className = "catalog-detail__meta"
}) {
  const normalizedItems = (items || []).filter(Boolean);

  if (normalizedItems.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {normalizedItems.map((item) => (
        <span key={item}>{item}</span>
      ))}
    </div>
  );
}
